import CartService from './cart-service';
import { hamletApi } from '../../common/hamlet/hamlet-api';
import { hamletUser } from '../../common/hamlet/hamlet-user';

export default class Hamlet {
  identifiedProducts: any[];
  cartService: CartService;

  constructor() {
    this.identifiedProducts = [];
    this.cartService = new CartService();
  }

  init(cachingEnabled: boolean) {
    const initPromises = [this.getUser(cachingEnabled)];

    return Promise.all(initPromises)
      .then((response) => {
        const user = response[0];
        return Promise.resolve(user);
      })
      .catch(() => {
        // @todo: refactor main.js handle a reject state
        return Promise.reject();
      });
  }

  getUser(cachingEnabled: boolean, enableAisAvailableProducts = false) {
    return hamletUser.initUser(cachingEnabled, enableAisAvailableProducts);
  }

  getUserXsrfToken(cb) {
    return hamletUser.retrieveXsrfToken()
      .then(() => {
        cb();
      })
      .catch(() => {
        cb();
      });
  }

  isLoggedIn() {
    return hamletUser.getToken() && hamletUser.isLoggedIn();
  }

  getSites() {
    return hamletUser.getSites();
  }

  getSitesByProduct(availableProducts) {
    return hamletUser.getSitesByProduct(availableProducts);
  }

  checkExtendedTrialAvailability(migrationSourceUuid, productKey, cloudSiteIds) {
    return hamletUser.checkExtendedTrialAvailability(migrationSourceUuid, productKey, cloudSiteIds);
  }

  getExtendedTrialAvailability() {
    return hamletUser.getExtendedTrialAvailability();
  }

  getExtendedTrialAvailableSites() {
    const result = this.getExtendedTrialAvailability();
    if (!result || !result.cloudCreation.available) {
      return [];
    }
    return Object.keys(result.sites).filter(cloudId => result.sites[cloudId].available);
  }

  validateEmail(email: string) {

    const options = {
      url: `/1.0/public/aid/exists/${email}`
    };

    return hamletApi.post(options)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  }

  mapHamletData(formData) {

    return {
      "contactDetails": {
        "email": formData.email,
        "firstName": formData.firstName,
        "lastName": formData.lastName
      },
      "organisationDetails": null,
      "onDemandAccountDetails": {
        "accountName": formData.accountName,
        "adminUsername": "admin",
        "adminPassword": formData.aodPass,
        "productKeys": formData.productKeys,
        "timeZone": null
      },
      "termsOfServiceAccepted": true,
      "creditCardDetails": null
    };
  }

  identifyProducts() {
    return this.cartService.init()
      .then(products => {
        this.setIdentifiedProducts(products);
        return Promise.resolve(products);
      })
      .catch(() =>  Promise.reject());
  }

  getIdentifiedProducts() {
    return this.identifiedProducts;
  }

  setIdentifiedProducts(products) {
    this.identifiedProducts = products;
  }

  getCartServiceItems() {
    return this.cartService.getItems();
  }

  setCartServiceItems(items) {
    this.cartService.setItems(items);
  }

  hasAddons() {
    return this.cartService.addons();
  }

  getAddons() {
    return this.cartService.getAddons();
  }

  getCoreProducts() {
    return this.cartService.getCoreProducts();
  }

  getEulas() {
    return this.cartService.getEulas();
  }

}
